import Image from 'next/image';

import CircleIcon from '@/ui/CircleIcon/CircleIcon';
import { Button, SectionTitle } from '@/ui/index';

import styles from './SpecialOffers.module.scss';

const Card = ({ data, point }) => {
  const renderIconOrText = (() => {
    if (data?.icon?.path) {
      return (
        <CircleIcon
          className={styles.circleIcon}
          path={data.icon.path}
          alt={data.icon.alt}
        />
      );
    }

    return <CircleIcon className={styles.circleIcon}>{point}</CircleIcon>;
  })();

  return (
    <article
      className={styles['card-item']}
      itemScope
      itemType='http://schema.org/Article'
    >
      <div>
        <div className={styles['card-item__icon-wrapper']}>
          {renderIconOrText}
        </div>
        <div className={styles['card-item__content']}>
          {data?.title && (
            <SectionTitle titleModify={styles['card-item__title']}>
              {data.title}
            </SectionTitle>
          )}
        </div>
      </div>
      <div>
        <Button
          variant={'white'}
          Component={'router'}
          href={data.link}
          className={styles.link}
        >
          Details
        </Button>
      </div>
      {data?.foreground?.path && (
        <Image
          src={data.foreground.path}
          alt={data?.foreground?.alt || data?.title}
          title={data?.foreground?.alt || data?.title}
          className={styles.foreground}
          loading='lazy'
          layout='fill'
        />
      )}
    </article>
  );
};

export default Card;
